import { AnalysisCohortResponse } from '../../api-models';
import { CohortScopeProps } from '../../types/buttons.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import { formatSnapshot } from '../../utils/formatters';

import BaseAdapter from './baseAdapter';

export default class PostAllCohorts extends BaseAdapter<AnalysisCohortResponse[]> implements AdapterInterface {
  rawResponse: AnalysisCohortResponse[];

  async adaptResponse(): Promise<CohortScopeProps[]> {
    await this.fetchApiResponse('/api/get-cohorts', HTTPMethod.Post);
    return this.displayResponse();
  }

  async displayResponse(): Promise<CohortScopeProps[]> {
    return this.rawResponse.map((campaign: AnalysisCohortResponse) => ({
      id: campaign.cohort_id.toString(),
      name: campaign.name,
      formattedStart: formatSnapshot(campaign.start_snapshot, 'long'),
      formattedEnd: formatSnapshot(campaign.end_snapshot, 'long'),
      start: campaign.start_snapshot,
      end: campaign.end_snapshot,
      tags: campaign.tags,
      savedOn: campaign.saved_on,
    }));
  }
}
